import { $t } from '@previo/core'

const ds_t = $t

export { ds_t as $t }
